import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Tags:", -1)
const _hoisted_2 = {
  class: "tags-list list-disk",
  "data-testing": "tags-list"
}
const _hoisted_3 = { class: "tag__name" }
const _hoisted_4 = ["onClickOnce", "data-testing"]

import { PropType } from "vue";
import { SectionConcepts } from "@/models/product-section.model";
import { mdiDelete } from "@mdi/js";


export default /*#__PURE__*/_defineComponent({
  __name: 'TagsList',
  props: {
  tags: {
    type: Array as PropType<SectionConcepts[]>,
    default: () => []
  },
  canEditContent: {
    type: Boolean,
    default: false,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tags, (tag) => {
        return (_openBlock(), _createElementBlock("li", {
          key: tag.id
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(tag.name), 1),
          (__props.canEditContent)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn-3 float-right",
                onClickOnce: ($event: any) => (_ctx.$emit('removeTag', tag.id)),
                "data-testing": `remove-concept-tag-${tag.id}`
              }, [
                _createVNode(_component_SVGIcon, { path: _unref(mdiDelete) }, null, 8, ["path"])
              ], 40, _hoisted_4))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})